import defaults from 'superagent-defaults';
import superagent from 'superagent-bluebird-promise';
import createRequestMetrics from 'request-metrics';
import requestLogger from 'request-logger';

import { environment, stubHost } from 'config';

export default ({ metricsApiKey, label } = {}) => {
  const request = defaults(superagent);

  request.set('Accept', 'application/json');

  if (stubHost && environment !== 'production') {
    request.withCredentials();
  }

  request.use(createRequestMetrics(metricsApiKey));
  request.use(requestLogger(label));

  return request;
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/create-request.js
 **/